import { render } from "./social.vue?vue&type=template&id=29f1ce70"
import script from "./social.vue?vue&type=script&lang=js"
export * from "./social.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__